import {SettingsKeyListResponse} from "@/types/service-response";

export default class SettingsKeyList {
  private constructor (
    readonly defaultValue: string,
    readonly name: string,
    readonly type: string,

  ) {}


  static createFromResponse (responseData: SettingsKeyListResponse): SettingsKeyList {
    return new SettingsKeyList(
        responseData.defaultValue,
        responseData.name,
        responseData.type
    )
  }

  static createFromResponseList (responseData: SettingsKeyListResponse[]): SettingsKeyList[]{
    return  responseData.map((item: SettingsKeyListResponse)=>{
      return new SettingsKeyList(
          item.defaultValue,
          item.name,
          item.type,
      )}
    )
  }
}